import { CurrencyAmount, ChainId as UniswapSDKChainId } from "@uniswap/sdk-core";
import { MONAD_LOGO } from "ui/src/assets";
import { USDT_MONAD_TESTNET } from "uniswap/src/constants/tokens";
import { Chain as BackendChainId } from "uniswap/src/data/graphql/uniswap-data-api/__generated__/types-and-hooks";
import { DEFAULT_NATIVE_ADDRESS_LEGACY, getQuicknodeEndpointUrl } from "uniswap/src/features/chains/evm/rpc";
import {
  NetworkLayer,
  RPCType,
  UniverseChainId
} from "uniswap/src/features/chains/types";
import { ElementName } from "uniswap/src/features/telemetry/constants";
export const MONAD_CHAIN_INFO = {
  id: UniverseChainId.MonadTestnet,
  testnet: true,
  sdkId: UniswapSDKChainId.MONAD_TESTNET,
  assetRepoNetworkName: void 0,
  backendChain: {
    chain: BackendChainId.MonadTestnet,
    backendSupported: true,
    isSecondaryChain: false,
    nativeTokenBackendAddress: void 0
  },
  bridge: void 0,
  docs: "https://docs.monad.xyz/",
  helpCenterUrl: void 0,
  label: "Monad Testnet",
  logo: MONAD_LOGO,
  name: "Monad Testnet",
  nativeCurrency: {
    name: "Monad",
    symbol: "MON",
    decimals: 18,
    address: DEFAULT_NATIVE_ADDRESS_LEGACY,
    logo: MONAD_LOGO
  },
  networkLayer: NetworkLayer.L1,
  pendingTransactionsRetryOptions: void 0,
  statusPage: void 0,
  supportsInterfaceClientSideRouting: true,
  supportsGasEstimates: true,
  supportsV4: false,
  urlParam: "monad_testnet",
  rpcUrls: {
    [RPCType.Public]: {
      http: [getQuicknodeEndpointUrl(UniverseChainId.MonadTestnet)]
    },
    [RPCType.Default]: {
      http: [getQuicknodeEndpointUrl(UniverseChainId.MonadTestnet)]
    },
    [RPCType.Interface]: {
      http: [getQuicknodeEndpointUrl(UniverseChainId.MonadTestnet)]
    }
  },
  wrappedNativeCurrency: {
    name: "Wrapped Monad",
    symbol: "WMON",
    decimals: 18,
    address: "0x760AfE86e5de5fa0Ee542fc7B7B713e1c5425701"
  },
  blockPerMainnetEpochForChainId: 1,
  blockWaitMsBeforeWarning: void 0,
  elementName: ElementName.ChainMonadTestnet,
  explorer: {
    name: "Monad Explorer",
    url: "https://testnet.monadexplorer.com/"
  },
  infoLink: "https://app.uniswap.org/explore",
  infuraPrefix: void 0,
  interfaceName: "monad",
  spotPriceStablecoinAmount: CurrencyAmount.fromRawAmount(USDT_MONAD_TESTNET, 1e10),
  stablecoins: [USDT_MONAD_TESTNET]
};
